import { render } from "./DocumentFieldTrainingTable.vue?vue&type=template&id=20a2546c&scoped=true&ts=true"
import script from "./DocumentFieldTrainingTable.vue?vue&type=script&lang=ts"
export * from "./DocumentFieldTrainingTable.vue?vue&type=script&lang=ts"

import "./DocumentFieldTrainingTable.vue?vue&type=style&index=0&id=20a2546c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a2546c"]])

export default __exports__